import React from "react";
import { BsLockFill, BsUnlock } from "react-icons/bs";
import { IconContext } from "react-icons/lib";
import {
  MdAccountBalance, MdClear,
  MdCreate,
  MdDeleteForever,
  MdRefresh,
  MdViewList
} from "react-icons/md";
import { CustomIcon } from "./CustomSvgIcons";
import "./Icons.scss";

const Icons = (props) => {
  const { icon, ...rest } = props;
  switch (icon) {
    case "dashboard":
      return (
        <span className="custom-icon">
          <CustomIcon icon="dashboard" {...rest}></CustomIcon>
        </span>
      );
    case "employees":
      return (
        <span className="custom-icon">
          <CustomIcon icon="employees" {...rest}></CustomIcon>
        </span>
      );
    case "list":
      return <MdViewList {...rest} />;

    case "closebtn":
      return (
        <span className="close-icon">
          <MdClear {...rest} />
        </span>
      );
    case "edit":
      return <MdCreate className="edit" />;
    case "unlocked":
      return <BsUnlock className="edit" />;
    case "locked":
      return <BsLockFill className="edit" />;
    case "delete":
      return (
        <IconContext.Provider value={{ color: "red" }}>
          <MdDeleteForever className="trash"></MdDeleteForever>
        </IconContext.Provider>
      );
    case "switch":
      return <MdRefresh></MdRefresh>;
    case "accounts":
      return <MdAccountBalance></MdAccountBalance>;
    case "settings":
      return <CustomIcon icon="settings" />;
    default:
      return <></>;
  }
};

export default Icons;
